import { useLayoutEffect, useRef, useState } from 'react'

type UseTruncationTooltipParams = {
  truncated: boolean
  displayLabel: string
  isActive: boolean
  textSize: 'sm' | 'base'
}

/** Tooltip when length-capped or when CSS clips the label (`scrollWidth` > `clientWidth`). */
export function useTruncationTooltip({ truncated, displayLabel, isActive, textSize }: UseTruncationTooltipParams) {
  const labelRef = useRef<HTMLSpanElement>(null)
  const [isCssOverflow, setIsCssOverflow] = useState(false)

  useLayoutEffect(() => {
    const element = labelRef.current
    if (!element) return

    const measure = () => {
      const node = labelRef.current
      if (!node) return
      setIsCssOverflow(node.scrollWidth > node.clientWidth)
    }

    measure()
    const ro = new ResizeObserver(measure)
    ro.observe(element)
    return () => ro.disconnect()
  }, [displayLabel, isActive, textSize])

  return { labelRef, showTooltip: truncated || isCssOverflow }
}
